import React from "react";
import { Stack } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import Textarea from "src/components/Textarea";
import { FormLabel } from "src/components/atoms/FormLabel";
import { ADJUSTMENT_REASON_OTHER } from "../constants";

export const AdjustmentComment = () => {
  const { control, watch } = useFormContext();

  const fieldName = "adjustmentComment";

  const shouldBeRequired = watch("adjustmentReasonCode") === ADJUSTMENT_REASON_OTHER;

  return (
    <Stack gap={2}>
      <FormLabel htmlFor={fieldName} required={shouldBeRequired}>
        Adjustment Comment
      </FormLabel>
      <Controller
        control={control}
        name={fieldName}
        rules={{ required: shouldBeRequired }}
        render={({ field: { name, value, onChange, ref }, fieldState: { error } }) => (
          <Textarea
            placeholder="Enter adjustment comment"
            onChange={onChange}
            value={value}
            width="100%"
            name={name}
            ref={ref}
            error={error}
          />
        )}
      />
    </Stack>
  );
};
